import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { getFAQItems } from '@/mocks/categories';

export default function FAQPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqItems = getFAQItems(t);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 mb-6 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t('back_to_home')}
            </button>

            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-6">
              {t('faq')}
            </h1>

            <p className="text-foreground-600 mb-8 leading-relaxed">
              Find answers to the most common questions about CSSBuy Spreadsheet, buying guides, shipping, safety, and more.
            </p>

            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg border border-background-200 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between p-5 text-left hover:bg-background-50 transition-colors"
                  >
                    <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                    <i
                      className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openIndex === index && (
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-background-200">
              <div className="bg-primary-50 rounded-xl p-6 md:p-8 text-center">
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                  Still have questions?
                </h3>
                <p className="text-sm text-foreground-600 mb-6">
                  Contact us for more information or visit the main website to browse products.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <button
                    onClick={() => navigate('/contact')}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap"
                  >
                    <i className="ri-mail-line" />
                    Contact Us
                  </button>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-700 font-medium rounded-lg border border-background-200 hover:bg-background-100 transition-colors text-sm whitespace-nowrap"
                  >
                    <i className="ri-external-link-line" />
                    {t('explore_spreadsheet')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}